// extracted by mini-css-extract-plugin
module.exports = {"spacer":"TeamDropdown-styles_spacer__3mTNn"};